import { z } from "zod/v4";
export const YearSchema = z.object({ year: z.int().min(100) }); // 0-99はJSにより1990-1999として解釈されるため
export const MonthSchema = z.object({ month: z.int().min(1).max(12) });
export const DaySchema = z.object({ day: z.int().min(1).max(31) });
export const HourSchema = z.object({ hour: z.int().min(0).max(23) });
export const MinuteSchema = z.object({
    minute: z.int().min(0).max(59),
});
export const SecondSchema = z.object({
    second: z.int().min(0).max(59),
});
export const MillisecondSchema = z.object({
    millisecond: z.int().min(0).max(999),
});
//# sourceMappingURL=time-schema.js.map